export const agentIdCookieKey = 'agent-id';
export const chatSourceCookieKey = 'chat-source';
//# sourceMappingURL=internalTools.js.map